import React, { FC, useEffect, useRef, useState } from "react";
import { AutoComplete, Input, Radio, Button } from "antd";
import { DiscountType, Discount } from "../../data-types";
import styles from "./discount-row.css";
import { Icons } from "../vpd-icons/icons";

const {
  ["discount-container"]: discountContainerClassname,
  ["name-input"]: nameInputClassname,
  ["radio-buttons"]: radioButtonClassname,
  ["amount-input"]: amountInputClassname,
  ["rhs"]: rhsClassname,
} = styles as any;

type Props = {
  discount: Discount;
  onUpdate: (discount: Partial<Discount>) => void;
  onDelete: (id: number) => void;
  libraryDiscounts: string[];
  autoFocus?: boolean;
  onAutoFocus?: () => void;
  currencySymbol: string;
};

export const DiscountRow: FC<Props> = ({
  discount: { id, reason, type: initialType = "percent", amount },
  onUpdate,
  onDelete,
  libraryDiscounts = [],
  autoFocus = false,
  onAutoFocus,
  currencySymbol,
}) => {
  const discountInputRef = useRef<any>(null);

  const [type, setState] = useState(initialType);

  useEffect(() => {
    autoFocus && onAutoFocus && onAutoFocus();
  }, [autoFocus, onAutoFocus]);

  return (
    <div className={discountContainerClassname}>
      <AutoComplete
        placeholder="Reason"
        defaultValue={reason}
        className={nameInputClassname}
        options={libraryDiscounts.map((ld) => ({ value: ld }))}
        filterOption
        autoFocus={autoFocus}
        onBlur={(e) => {
          if ((e.target as HTMLInputElement).value !== reason) {
            onUpdate({
              id,
              reason: (e.target as HTMLInputElement).value || "",
            });
          }
        }}
      />
      <div className={rhsClassname}>
        <Radio.Group
          defaultValue={type}
          buttonStyle="solid"
          onChange={(e) => {
            setState(e.target.value);
            onUpdate({ id, type: e.target.value });
          }}
          className={radioButtonClassname}
        >
          <Radio.Button value={DiscountType.Percent}>percent</Radio.Button>
          <Radio.Button value={DiscountType.Amount}>amount</Radio.Button>
        </Radio.Group>
        <Input
          ref={discountInputRef}
          onFocus={() => {
            if (discountInputRef.current) {
              discountInputRef.current.select();
            }
          }}
          className={amountInputClassname}
          type="number"
          placeholder="Value"
          min="0"
          defaultValue={amount}
          prefix={type === DiscountType.Amount && currencySymbol}
          suffix={type === DiscountType.Percent && "%"}
          onBlur={(e) => {
            const value = parseFloat(e.target.value);
            if (!Number.isNaN(value) && value !== amount) {
              onUpdate({
                id,
                amount: value,
              });
            }
          }}
        />
        <Button icon={Icons.Delete} shape="circle" onClick={() => onDelete(id)} type="link" />
      </div>
    </div>
  );
};
